<template>
  <div id="tracker">
    <div class="columns">
      <div class="column">
       Hier komen dan kekke grafiekjes over trackers?
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '../Surveys/BarChart'

export default {
  name: 'Tracker',
  components: {
    BarChart
  },
  props: {
    entityId: String,
    highlightDate: Object,
    parkingChartData: Object,
    chartMaxYAxis: Number,
  },
}
</script>
